@if (cards().length && columnCount()) {
  <div class="social-wall" [class.social-wall--measuring]="!isSettled()">
    @for (column of columns(); track $index) {
      <div class="social-wall__column">
        @for (card of column; track card.key) {
          <div class="social-wall__item" #cardElement [attr.data-key]="card.key">
            <lib-social-wall-card [item]="card.item" (open)="openDetail(card.index)"></lib-social-wall-card>
          </div>
        }
      </div>
    }
  </div>
}
